import { ACTIONS } from '../constants/event-email-history';

const INITIAL_STATE = {
  history: {
    loading: false,
    error: null,
    requestId: null,
    requestParams: null,
    history: [],
    summary: [],
    raw: null,
  },
  sendEmail: {
    loading: false,
    error: null,
    response: null,
  },
};

export const eventEmailHistory = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTIONS.EVENT_EMAIL_HISTORY_FETCH_START:
      return {
        ...state,
        history: {
          ...state.history,
          loading: true,
          error: null,
          requestParams: action.payload || null,
        },
      };

    case ACTIONS.EVENT_EMAIL_HISTORY_FETCH_SUCCESS: {
      const payload = action.payload || {};
      const data = payload.data || {};
      return {
        ...state,
        history: {
          loading: false,
          error: null,
          requestId: payload.request_id || null,
          requestParams: state.history.requestParams,
          history: Array.isArray(data.history) ? data.history : [],
          summary: Array.isArray(data.summary) ? data.summary : [],
          raw: payload,
        },
      };
    }

    case ACTIONS.EVENT_EMAIL_HISTORY_FETCH_FAILURE:
      return {
        ...state,
        history: {
          ...state.history,
          loading: false,
          error: action.payload,
        },
      };

    case ACTIONS.EVENT_EMAIL_HISTORY_SEND_START:
      return {
        ...state,
        sendEmail: {
          ...state.sendEmail,
          loading: true,
          error: null,
        },
      };

    case ACTIONS.EVENT_EMAIL_HISTORY_SEND_SUCCESS: {
      const payload = action.payload || {};
      const data = payload.data || {};
      return {
        ...state,
        history: {
          ...state.history,
          history: Array.isArray(data.history) ? data.history : state.history.history,
          summary: Array.isArray(data.summary) ? data.summary : state.history.summary,
          requestId: payload.request_id || state.history.requestId,
          raw: payload,
        },
        sendEmail: {
          loading: false,
          error: null,
          response: payload,
        },
      };
    }

    case ACTIONS.EVENT_EMAIL_HISTORY_SEND_FAILURE:
      return {
        ...state,
        sendEmail: {
          ...state.sendEmail,
          loading: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};
